import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "table table-striped" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { colspan: "99" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "my-5"
}
const _hoisted_10 = { class: "d-flex align-items-center mt-3" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_14 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = { class: "table table-striped" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { colspan: "99" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "d-flex justify-content-end mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_localized_text, {
              type: "h5",
              localizedKey: "Final Transportation",
              text: "Final Transportation"
            }),
            (!_ctx.isReadOnly)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-tertiary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editTransportation()))
                }, [
                  (!_ctx.filteredFinalTransportation)
                    ? (_openBlock(), _createBlock(_component_localized_text, {
                        key: 0,
                        localizedKey: "Add",
                        text: "Add"
                      }))
                    : (_openBlock(), _createBlock(_component_localized_text, {
                        key: 1,
                        localizedKey: "Edit",
                        text: "Edit"
                      }))
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_4,
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Material",
                    text: "Material"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Origin Country",
                    text: "Origin Country"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Destination Country",
                    text: "Destination Country"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Transports",
                    text: "Transports"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Transport CO2e Grams",
                    text: "Transport CO2e Grams"
                  })
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (!_ctx.filteredFinalTransportation)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                    _createElementVNode("td", _hoisted_7, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "No Elements Found",
                        text: "No Elements Found"
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Final Product",
                        text: "Final Product"
                      })
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.filteredFinalTransportation.countryOfOrigin), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.filteredFinalTransportation.countryOfDestination), 1),
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredFinalTransportation.transportTypes, (type, j) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "fs-12 mb-1",
                          key: j
                        }, _toDisplayString(type.transportType) + " - " + _toDisplayString(_ctx.$filters.approximation(type.transportCO2)), 1))
                      }), 128))
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(_ctx.$utils.getTotal("transportCO2", _ctx.finalTransportation))), 1)
                  ]))
            ])
          ])
        ]),
        (_ctx.finalTransportation.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Are you responsible for transporting the finished products to retailers or customers?",
                text: "Are you responsible for transporting the finished products to retailers or customers?",
                class: "fw_700"
              }),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn me-2", _ctx.hasTransportToClientSection ? 'btn-tertiary' : 'btn-secondary withBorder']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hasTransportToClientSection = true)),
                  disabled: _ctx.isReadOnly
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Yes",
                    text: "Yes"
                  })
                ], 10, _hoisted_11),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn", !_ctx.hasTransportToClientSection ? 'btn-tertiary' : 'btn-secondary withBorder']),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hasTransportToClientSection = false)),
                  disabled: _ctx.isReadOnly
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "No",
                    text: "No"
                  })
                ], 10, _hoisted_12)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasTransportToClientSection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_localized_text, {
                  type: "h5",
                  localizedKey: "Transportation to Retailers/Customer",
                  text: "Transportation to Retailers/Customer"
                }),
                (!_ctx.isReadOnly)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-tertiary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editTransportationToCustomer()))
                    }, [
                      (!_ctx.filteredTransportationToCustomer)
                        ? (_openBlock(), _createBlock(_component_localized_text, {
                            key: 0,
                            localizedKey: "Add",
                            text: "Add"
                          }))
                        : (_openBlock(), _createBlock(_component_localized_text, {
                            key: 1,
                            localizedKey: "Edit",
                            text: "Edit"
                          }))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_15,
              _createElementVNode("table", _hoisted_16, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Material",
                        text: "Material"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Origin Country",
                        text: "Origin Country"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Destination Country",
                        text: "Destination Country"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Transports",
                        text: "Transports"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Transport CO2e Grams",
                        text: "Transport CO2e Grams"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (!_ctx.filteredTransportationToCustomer)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                        _createElementVNode("td", _hoisted_18, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "No Elements Found",
                            text: "No Elements Found"
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Final Product",
                            text: "Final Product"
                          })
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.filteredTransportationToCustomer.countryOfOrigin), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.filteredTransportationToCustomer.countryOfDestination), 1),
                        _createElementVNode("td", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTransportationToCustomer.transportTypes, (type, j) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "fs-12 mb-1",
                              key: j
                            }, _toDisplayString(type.transportType) + " - " + _toDisplayString(_ctx.$filters.approximation(type.transportCO2)), 1))
                          }), 128))
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(_ctx.$utils.getTotal("transportCO2", _ctx.transportationToCustomer))), 1)
                      ]))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("button", {
                class: "btn btn-secondary me-3",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.back()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Previous",
                  text: "Previous"
                })
              ]),
              _createElementVNode("button", {
                class: "btn btn-tertiary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.next()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Continue",
                  text: "Continue"
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}